import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coachtraining-affiliation',
  templateUrl: './coachtraining-affiliation.component.html',
  styleUrls: ['./coachtraining-affiliation.component.scss']
})
export class CoachtrainingAffiliationComponent implements OnInit {
  /**
   * Definição da identificão da sessão/depto Capacitação
   */
  public departmentId: string = '26';

  constructor() { }

  ngOnInit(): void {
  }

}
